module.exports = __webpack_public_path__ + "static/media/C4.367819d5.jpg";